import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import Modal from '../../../Util/Modal/CustomModal';
import Fetch from '../../../functions/Fetch';

import ReactTooltip from "react-tooltip";
import { useSelector, useDispatch } from 'react-redux';
import CustomForm from '../../../Util/Form/CustomForm/CustomForm';
import DataTable from 'react-data-table-component';
import styled from 'styled-components';

import config from "../../../../../../config/config";

import './CustomList.css';
import CustomTab from "./CustomTab";
const TextField = styled.input``;

const FilterComponent = ({ filterText, onFilter, onClear }) => (
  <>
    <TextField
      id="search"
      type="text"
      placeholder="Pesquisa"
      aria-label="Search Input"
      value={filterText}
      onChange={onFilter}
      className="custom-list-search"
    />
  </>
);

function CustomList(props) {
  const dispatch = useDispatch();

  const defaultPropsForm = {
    type: 'container',
    canView: props.list.canView,
    canEdit: props.list.canEdit,
    canDelete: props.list.canDelete,
    canAdd: props.list.canAdd,
    key_data_rows: `custom_list_data_${props.list.endpoint}`,
    pathEdit: '',
    pathView: '',
    pathDelete: '',
    filter: {},
    tabFilters: [],
    fieldsShowOnDelete: [],
    showPrintButtons: false,
    columns: [],
    columnsButtons: [],
    rows: [],
    intervalRefresh: 0
  }

  const list = { ...defaultPropsForm, ...props.list };

  const navigate = useNavigate();

  let [showModal, setShowModal] = useState(false);
  let [modalTitle, setModalTitle] = useState('');
  let [modalItem, setModalItem] = useState({});
  let [columns, setColumns] = useState([]);
  const modalContent = useSelector((state) => { return state.core.session.custom_form_content_modal });
  const rows = useSelector((state) => { return state.core.session[list.key_data_rows] ? state.core.session[list.key_data_rows] : [] });
  let interval = false;

  useEffect(() => {
    loadData();
    if (props.list.endpoint) {
      if (list.intervalRefresh) {
        interval = setInterval(async () => {
          loadData();
        }, list.intervalRefresh * 1000)
      }
    }

    return () => {
      clearInterval(interval);
    };

  }, []);

  const loadData = async (preparedValues) => {
    let defaultRows = [];
    let percentual = (100 / (list.columns.length + list.columnsButtons.length + 1)) + 2;
    let defaultColumns = [];
    for (const item of list.columns) {
      defaultColumns.push({
        name: item.label,
        selector: row => row[item.name],
        column: item.name,
        width: item.width ? item.width : percentual + '%'
      })
    }
    for await (const buttons of list.columnsButtons) {
      for await (const button of buttons.buttons) {
        defaultColumns.push({
          name: button.label,
          selector: row => row[button.label],
          column: button.name,
          width: button.width ? button.width : percentual + '%'
        });
      }

    }

    if (list.canEdit || list.canView || list.canDelete || list.canDownload) {
      defaultColumns.push({
        name: 'Ações',
        selector: row => row.button_actions
      });
    } else {
      defaultColumns.push({
        name: '',
        selector: null
      });
    }

    if (props.list.endpoint) {
      defaultRows = await Fetch.post(props.list.endpoint, { filter: { ...list.filter, ...preparedValues } });
      let index = 0;
      for await (const item of defaultRows) {
        for await (const buttons of list.columnsButtons) {
          for await (const button of buttons.buttons) {
            defaultRows[index][button.label] = (
              <>
                <a
                  onClick={() => { button.onClick(item) }}
                  className="btn btn-primary btn-sm btn-action"
                  data-tip
                  data-for="registerTip">
                  {button.icon ? <i className={button.icon} /> : button.label}
                </a>
              </>
            )
          }
        }

        let downloadData = ''
        if (list.canDownload && list.fieldToDownload) {
          downloadData = item[list.fieldToDownload] + ''
        }

        defaultRows[index].button_actions = (
          <>
            {(list.canDownload && downloadData && downloadData != "") && (
              <>
                <a
                  className="btn btn-dark btn-sm btn-action"
                  href={`${!downloadData.includes('http') ? config.endpoints.backend : ''}${downloadData}`}
                  download={true}
                  target="_blank"
                  data-tip data-for={"tooltip-download-" + item.id}
                  data-testid={`download-${item[list.columns[0].name]}`}
                >
                  <i className="fas fa-download">
                  </i>
                </a>
                <ReactTooltip id={"tooltip-download-" + item.id} place="top" effect="solid">
                  Download
                </ReactTooltip>
              </>
            )}
            {(list.canDownload && (downloadData == "" || !downloadData)) && (
              <>
                <button
                  className="btn btn-secondary btn-sm btn-action"
                  data-tip data-for={"tooltip-notdownload-" + item.id}
                  data-testid={`notdownload-${item[list.columns[0].name]}`}
                  disabled={true}
                >
                  <i className="fas fa-download">
                  </i>
                </button>
                <ReactTooltip id={"tooltip-notdownload-" + item.id} place="top" effect="solid">
                  Sem arquivo
                </ReactTooltip>
              </>
            )}
          </>
        );
        index++;
      }
      setColumns(defaultColumns);
      setRows(defaultRows);
    } else {
      setColumns(defaultColumns);
      setRows(list.rows);
    }
  }

  const setModalContent = content => {
    dispatch({ type: 'UPDATE_SESSION', key: 'custom_form_content_modal', value: content });
  }
  const setRows = content => {
    dispatch({ type: 'UPDATE_SESSION', key: list.key_data_rows, value: content });
  }

  const [filterText, setFilterText] = React.useState('');
  const [resetPaginationToggle, setResetPaginationToggle] = React.useState(false);

  const filteredItems = rows.filter(
    item => item && JSON.stringify(item).toLowerCase().includes(filterText.toLowerCase())
  );

  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText('');
      }
    };

    return (
      <FilterComponent onFilter={e => setFilterText(e.target.value)} onClear={handleClear} filterText={filterText} />
    );
  }, [filterText, resetPaginationToggle]);

  let formFilters = { ...props.list.formFilters, loadData };

  return (
    <>
      <Modal
        show={showModal}
        handleShow={() => setShowModal(true)}
        handleClose={() => setShowModal(false)}
        title={modalTitle}
        content={modalContent}
      />
      {props.list.formFilters && <CustomForm form={formFilters} />}
      {props.list.tabFilters && <CustomTab tab={props.list.tabFilters} loadData={loadData} />}
      <DataTable
        columns={columns}
        data={filteredItems}
        pagination
        paginationResetDefaultPage={resetPaginationToggle}
        subHeader
        subHeaderComponent={subHeaderComponentMemo}
      />
    </>
  )
}
export default CustomList;